import classNames from 'classnames';
import { Plus } from 'phosphor-react';
import type { PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';
import { ButtonCtaGhost } from '../button/button';

type LoadMoreProps = {
  hasMore: boolean;
  onLoadMore: () => void;
  dataLength: number; // used to determine if new data arrived after load more was clicked
  className?: string;
};

export const LoadMore = ({ hasMore, onLoadMore, dataLength: givenDataLength, className, children }: PropsWithChildren<LoadMoreProps>) => {
  const [dataLength, setDataLength] = useState(givenDataLength);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (dataLength !== givenDataLength) {
      setIsLoading(false);
    }
    setDataLength(givenDataLength);
  }, [dataLength, givenDataLength]);

  const handleLoadMoreClick = () => {
    setIsLoading(true);
    onLoadMore();
  };

  return (
    <div className={classNames(className, 'flex flex-col gap-100')}>
      {children}
      {
        hasMore
          ? <ButtonCtaGhost
            className="self-center"
            disabled={isLoading}
            onClick={handleLoadMoreClick}
            icon={Plus}
          >
              Mehr laden
          </ButtonCtaGhost>
          : null
      }
    </div>
  );
};
